import React from "react";

const BannerImg = ({ srcUrl, altText }) => {
  return <img className="img-fluid mx-auto d-block" src={srcUrl} alt={altText} />;
};

export default React.memo(BannerImg);
